gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

let lastScrollTop = 0;

window.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", scrolling);

  const videos = document.querySelectorAll(".lazy-video");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const source = video.querySelector("source");
        video.src = video.dataset.src;
        source.src = source.dataset.src;
        video.load();
        observer.unobserve(video);
      }
    });
  });
  videos.forEach((video) => observer.observe(video));

  // videoThumbnail();
  // const elements = Array.from(document.querySelectorAll(".card-post"));
  // generateThumbnailsInBatch(elements);

  // Animatiooons
  // Home hero
  document.fonts.ready.then(() => {
    if (document.querySelector(".section-HomeHero")) animHomeHero();

    // animation zoom
    if (document.querySelector("[pam-zoomin]")) animZoom();

    // Parallax
    if (document.querySelector("[pam-parallax]")) animParallax();

    if (document.querySelector("[pam-fadein]")) animFadeIn();

    // Anime Text
    if (document.querySelector("[pam-textSlidein]")) animTextSlidein();

    if (document.querySelector(".product-utilisation")) {
      ScrollTrigger.create({
        trigger: ".product-utilisation",
        start: "top 40%",
        end: "bottom 100%",
        onEnter: () => {
          gsap.to(".textFadeIn", {
            duration: 0.6,
            opacity: 1,
            ease: "power2.out",
          });
        },
      });
    }
  });
});
function animFadeIn() {
  // animation fade in
  document.querySelectorAll("[pam-fadein]").forEach((el) => {
    const element = el;
    ScrollTrigger.create({
      trigger: element,
      start: "top 80%",
      end: "bottom 100%",
      onEnter: () => {
        gsap.fromTo(
          element.querySelectorAll(".card-post"),
          {
            y: "-3%",
            opacity: 0,
          },
          {
            duration: 0.6,
            y: 0,
            opacity: 1,
            ease: "power2.out",
            stagger: 0.1,
          },
        );
      },
      onLeaveBack: () => {
        gsap.fromTo(
          element.querySelectorAll(".card-post"),
          {
            y: 0,
            opacity: 1,
          },
          {
            duration: 0.6,
            y: "-3%",
            opacity: 0,
            ease: "power2.out",
            stagger: 0.1,
          },
        );
      },
    });
  });
}
function animTextSlidein() {
  // const observerParallax = new IntersectionObserver((entries, observer) => {
  //   entries.forEach((entry) => {
  //     const textToAnimate = entry.target.querySelector(".textToAnimate");
  //     new SplitText(textToAnimate, { type: "lines" });
  //     new SplitText(textToAnimate, { type: "lines" });

  //     const textDiv = entry.target.querySelectorAll(".textToAnimate > div");
  //     const textDivDiv = entry.target.querySelectorAll(
  //       ".textToAnimate > div > *",
  //     );
  //     gsap.set(textDiv, { overflow: "hidden" });
  //     gsap.set(textDivDiv, { y: "80px" });

  //     ScrollTrigger.create({
  //       trigger: entry.target,
  //       start: "top bottom",
  //       end: "bottom top",
  //       once: true,
  //       onEnter: () => {
  //         gsap.to(textDivDiv, {
  //           stagger: 0.1,
  //           delay: 0.5,
  //           duration: 0.5,
  //           y: 0,
  //           ease: "expo.out",
  //         });
  //       },
  //     });
  //   });
  // });
  document.querySelectorAll("[pam-textSlidein]").forEach((el) => {
    // observerParallax.observe(el);

    const textToAnimate = el.querySelector(".textToAnimate");
    new SplitText(textToAnimate, { type: "lines" });
    new SplitText(textToAnimate, { type: "lines" });

    const textDiv = el.querySelectorAll(".textToAnimate > div");
    const textDivDiv = el.querySelectorAll(".textToAnimate > div > *");
    gsap.set(textDiv, { overflow: "hidden" });
    gsap.set(textDivDiv, { y: "110%" });

    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      once: true,
      onEnter: () => {
        gsap.to(textDivDiv, {
          stagger: 0.1,
          delay: 0.5,
          duration: 0.5,
          y: 0,
          ease: "expo.out",
        });
      },
    });
  });
}

function animParallax() {
  const observerParallax = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      const mediaParallax = entry.target;
      gsap.fromTo(
        mediaParallax,
        { y: "-5%" },
        {
          y: "5%",
          ease: "none",
          scrollTrigger: {
            trigger: entry.target,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        },
      );
    });
  });
  document.querySelectorAll("[pam-parallax]").forEach((el) => {
    observerParallax.observe(el);
  });
}

function animZoom() {
  const observerZoom = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      const element = entry.target;
      ScrollTrigger.create({
        trigger: element,
        start: "top 90%",
        end: window.innerHeight,
        onEnter: () => {
          gsap.to(element.querySelector(".zoom"), {
            duration: 1,
            scale: 1,
            ease: "power4.out",
          });
        },
        onEnterBack: () => {
          gsap.to(element.querySelector(".zoom"), {
            duration: 1,
            scale: 1,
            ease: "power4.out",
          });
        },
        onLeaveBack: () => {
          gsap.to(element.querySelector(".zoom"), {
            duration: 1,
            scale: 1.25,
            ease: "power4.out",
          });
        },
      });
    });
  });
  document.querySelectorAll("[pam-zoomin]").forEach((el) => {
    observerZoom.observe(el);
  });
}

function animHomeHero() {
  new SplitText(".section-HomeHero .textToAnimate", { type: "lines" });
  new SplitText(".section-HomeHero .textToAnimate", { type: "lines" });
  gsap.set(".section-HomeHero .textToAnimate > div", { overflow: "hidden" });
  gsap.set(".section-HomeHero .textToAnimate > div > *", { y: "80px" });

  gsap.set(".section-HomeHero .textToAnimate", { opacity: 1 });
  gsap.set(".section-HomeHero .textToAnimate > div > *", { y: "80px" });
  gsap.to(".section-HomeHero .textToAnimate > div > *", {
    stagger: 0.1,
    delay: 0.5,
    duration: 0.5,
    y: 0,
    ease: "expo.out",
  });
}

// function videoThumbnail() {
//   const options = {
//     root: null,
//     rootMargin: "0px",
//     threshold: 0.1,
//   };

//   const observer = new IntersectionObserver((entries, observer) => {
//     entries.forEach((entry) => {
//       console.log(entry.target);
//       if (entry.isIntersecting) {
//         const el = entry.target;
//         const video = el.querySelector("video");
//         console.log(video);
//         const canvas = document.createElement("canvas");
//         const context = canvas.getContext("2d");
//         const poster = el.querySelector(".poster");

//         video.currentTime = 2;

//         video.addEventListener(
//           "seeked",
//           generateThumbnail(el),
//           { once: true }, // Ensure this listener runs only once
//         );

//         observer.unobserve(el); // Stop observing once processed
//       }
//     });
//   }, options);

//   document.querySelectorAll(".card-post").forEach((el) => {
//     observer.observe(el);
//   });
// }

// function generateThumbnail(el) {
//   const video = el.querySelector("video");
//   const canvas = document.createElement("canvas");
//   const context = canvas.getContext("2d");
//   const poster = el.querySelector(".poster");

//   video.currentTime = 2;

//   return new Promise((resolve) => {
//     video.addEventListener(
//       "seeked",
//       function generateThumbnail() {
//         canvas.width = video.videoWidth;
//         canvas.height = video.videoHeight;

//         context.drawImage(video, 0, 0, canvas.width, canvas.height);

//         const thumbnailImage = canvas.toDataURL("image/png");
//         poster.classList.remove("opacity-0");
//         poster.src = thumbnailImage;

//         video.currentTime = 0;
//         resolve();
//       },
//       { once: true }, // Ensure this listener runs only once
//     );
//   });
// }

async function generateThumbnailsInBatch(elements, batchSize = 2) {
  for (let i = 0; i < elements.length; i += batchSize) {
    const batch = elements.slice(i, i + batchSize);
    await Promise.all(batch.map((el) => generateThumbnail(el)));
  }
}

function scrolling() {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  window.scrollY > 10 && scrollTop > lastScrollTop
    ? document.documentElement.classList.add("scroll-down")
    : document.documentElement.classList.remove("scroll-down");
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  if (window.scrollY > 100) document.documentElement.classList.add("not-top");
  else document.documentElement.classList.remove("not-top");
}

function goTo(div, offset) {
  window.scrollTo({
    top: document.querySelector(div).offsetTop - offset,
    left: 0,
    behavior: "smooth",
  });
}

function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function addToCart(e) {
  e.preventDefault();
  e.target.querySelector('[type="submit"]').disabled = true;

  let formData = Object.fromEntries(new FormData(e.target));

  // Gestion dynamique des propriétés (properties[])
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key]; // On enlève la propriété brute du formData
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties; // Ajout des propriétés dynamiques dans formData

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        addToCartErrors(erreurs);
        e.target.querySelector('[type="submit"]').disabled = false;
        return false;
      } else {
        hideAddToCartErrors();
      }
      // console.log(JSON.stringify(Object.fromEntries(new FormData(e.target))))
      updateCart(data);
      document.documentElement.classList.add("cart-drawer");
      e.target.querySelector('[type="submit"]').disabled = false;
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

function addToCartErrors(message) {
  document.querySelector(".product_errors").classList.remove("hidden");
  document.querySelector(".product_errors_message").textContent = message;
  return false;
}
function hideAddToCartErrors() {
  document.querySelector(".product_errors").classList.add("hidden");
}

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;

  currentValue--;
  e.parentNode.querySelector("input").value = currentValue;
  e.parentNode.querySelector("span").innerText = currentValue;
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(homeUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
      const swiper = new Swiper(".cart-product_swiper", {
        navigation: {
          prevEl: ".cart-swiper_nav div:first-of-type",
          nextEl: ".cart-swiper_nav div:last-of-type",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
        },
      });
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink();
};

window.reduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("span").textContent) - 1;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.increaseQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("span").textContent) + 1;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.remove("hidden");
        el.parentNode.parentNode.parentNode.querySelector(
          ".product_errors_message",
        ).textContent = erreurs;
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.changeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  // const quantity = parseInt(el.parentNode.querySelector('span').textContent) + 1
  const quantity = el.value;
  console.log(itemId);

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.remove("hidden");
        // el.parentNode.parentNode.parentNode.querySelector(
        //   ".product_errors_message"
        // ).textContent = erreurs;
        console.log(erreurs);
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=0`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de vider le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.emptyCart = () => {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Panier vidé avec succès", data);
    })
    .catch((error) => {
      console.error("Erreur emptyCart :", error);
    });
};

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");
      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
    })
    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}

function searchForm(e) {
  e.preventDefault();
  const query = e.target.querySelector('input[name="q"]').value;
  e.target.setAttribute("aria-selected", query == "" ? "false" : "true");

  if (e.target.querySelector('input[name="q"]').value == "") {
    removeSearch();
  } else {
    fetch(`/search?type=article&q=${encodeURIComponent(query)}&view=json`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        // chargement de la nouvelle grille
        const newSearch = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("#blog_articles").innerHTML;

        document.querySelector("#searchResults").innerHTML = newSearch;
        document.querySelector("#searchResults").classList.remove("hidden");
        document.querySelector("#blog_articles").classList.add("hidden");
        document.querySelector(".pager").classList.add("hidden");
        document.querySelector(".search_result").classList.remove("hidden");
        document.querySelector(".search_result span").textContent = query;
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
  }
}

function removeSearch() {
  document.querySelector(".search_result").classList.add("hidden");
  document.querySelector("#searchResults").innerHTML = "";
  document.querySelector("#searchResults").classList.add("hidden");
  document.querySelector("#blog_articles").classList.remove("hidden");
  document.querySelector('input[name="q"]').value = "";
  document
    .querySelector('input[name="q"]')
    .parentNode.setAttribute("aria-selected", "false");
}

function playVideo(e) {
  const video = e.querySelector("video");
  const button = e.querySelector("button");
  const poster = e.querySelector(".poster");

  if (!e.classList.contains("is-playing")) {
    // Ensure video is in a playable state before calling play()
    if (video.readyState >= 2) {
      try {
        video.muted = false;
        video
          .play()
          .then(() => {
            // Only update UI after successful play
            button.classList.add("hidden");
            poster.classList.add("opacity-0");
            e.classList.add("is-playing");
          })
          .catch((error) => {
            console.error("Error playing video:", error);
            video.muted = true; // Fallback for autoplay restrictions
          });
      } catch (error) {
        console.error("Unexpected play error:", error);
      }
    } else {
      console.warn("Video not ready to play.");
    }
  } else {
    try {
      video.pause();
      button.classList.remove("hidden");
      poster.classList.remove("opacity-0");
      e.classList.remove("is-playing");
    } catch (error) {
      console.error("Error pausing video:", error);
    }
  }
}

function playMutedVideo(e) {
  const video = e.querySelector("video");
  const poster = e.querySelector(".poster");

  video.muted = true;

  if (video.readyState >= 2) {
    try {
      video.play().then(() => {
        if (poster) {
          poster.classList.add("opacity-0");
        }
      });
    } catch (error) {
      console.error("Unexpected play error:", error);
    }
  } else {
    video.addEventListener(
      "canplay",
      () => {
        try {
          video
            .play()
            .then(() => {
              if (poster) {
                poster.classList.add("opacity-0");
              }
            })
            .catch((error) => {
              console.error("Error playing muted video after ready:", error);
            });
        } catch (error) {
          console.error("Unexpected error after video ready:", error);
        }
      },
      { once: true },
    );
  }
}

function pauseVideo(e) {
  const video = e.querySelector("video");
  video.pause();
}
function productFAQ(e) {
  if (e.parentNode.classList.contains("active"))
    e.parentNode.classList.remove("active");
  else {
    if (document.querySelector(".faq_item.active")) {
      document.querySelector(".faq_item.active").classList.remove("active");
    }
    e.parentNode.classList.add("active");
  }
}
